import { AmplitudeEvent } from './base-events';
/**
 * Base class for funnel events that require Amplitude Lookup enrichment.
 * Examples: add to cart, checkout, purchase, enrollment.
 */
export class FunnelEvent extends AmplitudeEvent {
  constructor(...args) {
    super(...args);
    /** Product engagement items for product engagement lookup. */
    this.productEngagement = void 0;
    /** Cart contents for cart lookup. */
    this.cartContents = void 0;
    /**
     * When true, product_engagement items missing from cart_contents are appended.
     * Only enabled for events where the engaged product must appear in cart_contents
     * (e.g. AddToCart, BuyNow, EnrollNow). Default false to avoid unintended merges
     * on other funnel events like checkout or coupon events.
     */
    this.shouldMergeEngagementToCart = false;
  }
  toEventProperties() {
    /** Maps ProductItem[] to lookup-key format ({product_id: "type-id"}) */
    const mapProductItems = items => items === null || items === void 0 ? void 0 : items.map(item => ({
      product_id: `${item.type}-${item.id}`
    }));
    const engagement = mapProductItems(this.productEngagement);
    const cart = mapProductItems(this.cartContents);

    /**
     * Append product_engagement items to cart_contents if they're not already present.
     * Guarded by shouldMergeEngagementToCart so only opted-in subclasses trigger this.
     */
    let mergedCart = cart;
    if (this.shouldMergeEngagementToCart && engagement !== null && engagement !== void 0 && engagement.length) {
      var _cart$map;
      const existingIds = new Set((_cart$map = cart === null || cart === void 0 ? void 0 : cart.map(item => item.product_id)) !== null && _cart$map !== void 0 ? _cart$map : []);
      const missingItems = engagement.filter(item => !existingIds.has(item.product_id));
      if (missingItems.length) {
        mergedCart = [...(cart !== null && cart !== void 0 ? cart : []), ...missingItems];
      }
    }
    return {
      ...super.toEventProperties(),
      product_engagement: engagement,
      cart_contents: mergedCart
    };
  }
}
export class RevenueObject {
  constructor(productId, price, quantity, revenueType, currency) {
    this.productId = productId;
    this.price = price;
    this.quantity = quantity;
    this.revenueType = revenueType;
    this.currency = currency;
  }
}
export class RevenueEvent extends FunnelEvent {
  constructor(orderId, paymentMethod, revenueObjects, currency, couponCode, totalValue, totalDiscountValue, totalItems) {
    super();
    this.orderId = orderId;
    this.paymentMethod = paymentMethod;
    this.revenueObjects = revenueObjects;
    this.currency = currency;
    this.couponCode = couponCode;
    this.totalValue = totalValue;
    this.totalDiscountValue = totalDiscountValue;
    this.totalItems = totalItems;
    this.eventName = 'revenue_event';
    this.category = 'commerce';
  }
  getRevenueObjects() {
    return this.revenueObjects;
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      order_id: this.orderId,
      payment_method: this.paymentMethod,
      revenue_items: this.revenueObjects.map(item => ({
        product_id: item.productId,
        price: item.price,
        quantity: item.quantity,
        revenue_type: item.revenueType,
        currency: this.currency
      })),
      currency: this.currency,
      coupon_code: this.couponCode,
      total_value: this.totalValue,
      total_discount_value: this.totalDiscountValue,
      total_items: this.totalItems
    };
  }
}
//# sourceMappingURL=funnel-event.js.map